"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReinsuranceCustomerService = void 0;
var React = __importStar(require("react"));
var IconReinsuranceCustomerService = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M19.7314,15 L17.4554,15 C17.2044,15 17.0004,14.796 17.0004,14.546 L17.0004,9.454 C17.0004,9.204 17.2044,9 17.4554,9 L19.7284,9 C19.9984,9.02 21.0004,9.825 21.0004,12.018 C21.0004,14.201 19.9994,14.985 19.7314,15 M7.0004,9.454 L7.0004,14.546 C7.0004,14.792 6.7434,15 6.4394,15 L4.4624,15 C4.1534,15 3.0004,14.254 3.0004,12.018 C3.0004,9.788 4.1654,9 4.4624,9 L6.4394,9 C6.7434,9 7.0004,9.208 7.0004,9.454 M19.7314,8 L18.9684,8 C18.6604,4.278 16.0924,2 12.1104,2 C8.0674,2 5.3644,4.328 5.0344,8 L4.4624,8 C3.6044,8 2.0004,9.179 2.0004,12.018 C2.0004,14.832 3.6044,16 4.4624,16 L6.4394,16 C7.2994,16 8.0004,15.348 8.0004,14.546 L8.0004,9.454 C8.0004,8.652 7.2994,8 6.4394,8 L6.0654,8 C6.3884,4.904 8.6274,3 12.1104,3 C15.5214,3 17.6374,4.863 17.9394,8 L17.4554,8 C16.6524,8 16.0004,8.652 16.0004,9.454 L16.0004,14.546 C16.0004,15.348 16.6524,16 17.4554,16 L18.0004,16 C17.9974,17.94 17.7324,19.825 14.9054,19.992 C14.6964,19.415 14.1484,19 13.5004,19 L10.5004,19 C9.6724,19 9.0004,19.673 9.0004,20.5 C9.0004,21.327 9.6724,22 10.5004,22 L13.5004,22 C14.1554,22 14.7084,21.574 14.9124,20.987 C18.9614,20.769 19.0004,17.472 19.0004,16 L19.7314,16 C20.6464,16 22.0004,14.734 22.0004,12.018 C22.0004,9.179 20.5224,8 19.7314,8" }))); };
exports.IconReinsuranceCustomerService = IconReinsuranceCustomerService;
exports.IconReinsuranceCustomerService.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReinsuranceCustomerService;
